<template>
  <Row>
    <Spin fix v-if="eachartLoad">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <p class="title">{{ count }}</p>
    <div class="eacharts">
      <Col span="12">
      <div ref="leftChartRef" class="leftEacharts"></div>
      </Col>
      <Col span="12">
      <div ref="rightChartRef" class="rightEacharts"></div>
      </Col>
    </div>
  </Row>
</template>

<script>
import * as echarts from 'echarts';
import customConfig from 'customConfig';
export default {
  props: {
    leftEachartsData: {
      type: Array,
      default() {
        return [];
      },
    },
    rightEachartsData: {
      type: Array,
      default() {
        return [];
      },
    },
    countSum: {
      type: Number,
      default() {
        return 0;
      },
    },
    areas: {
      type: Number,
      default() {
        return 0;
      },
    },
    eachartLoad: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      leftChart: null,
      rightChart: null,
      count: '',
    };
  },
  methods: {
    initDescribe() {
      const { layerInfo } = customConfig.themeService[this.$route.query.customId];
      const [[firstStart, firstEnd], [secondStart, secondEnd]] = layerInfo.describe.map(str =>
        str.split('%%')
      );
      this.count = `${firstStart}${this.countSum}${firstEnd},${secondStart}${this.areas}${secondEnd}`;
    },
    initLeftEachart() {
      this.leftChart = echarts.init(this.$refs.leftChartRef);
      var chartDom = document.querySelector('.leftEacharts');
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initRightEachart() {
      this.rightChart = echarts.init(this.$refs.rightChartRef);
      var chartDom = document.querySelector('.rightEacharts');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    handleResize() {
      this.leftChart.resize();
      this.rightChart.resize();
    },
  },
  watch: {
    leftEachartsData: {
      handler(val) {
        this.initDescribe();
        this.leftChart.setOption({
          series: [
            {
              data: val,
            },
          ],
        });
      },
      deep: true,
    },
    rightEachartsData: {
      handler(val) {
        this.initDescribe();
        this.rightChart.setOption({
          series: [
            {
              data: val,
            },
          ],
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.initDescribe();
    window.addEventListener('resize', this.handleResize);
    this.$nextTick(() => {
      this.initLeftEachart();
      this.initRightEachart();
    });
  },
  updated() {
    if (this.leftChart != null) {
      this.leftChart.resize();
    }
    if (this.rightChart != null) {
      this.rightChart.resize();
    }


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="less" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/deep/ .ivu-spin-fix {
  width: calc(~'100% + 38px') !important;
  left: -18px !important;
  top: -18px !important;
  height: 640px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

.eacharts {
  width: 100%;
  height: 200px;
  display: flex;

  .leftEacharts {
    width: 100%;
    height: 200px;
  }

  .rightEacharts {
    width: 100%;
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CultivatedLandComponent/Eacharts.vue